import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Row,
    Col
} from 'reactstrap';

import Isvg from 'react-inlinesvg';
import moveIcon from '../../../assets/svg/move.svg';
import moreIcon from '../../../assets/svg/more.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import xIcon from '../../../assets/svg/x.svg';



import moment from 'moment';
import { API_ENDPOINT, getAgeLimit, translateAgeLimitMessage } from '../../../constants';
import ErrorModal_v2 from '../../../components/errorModal_v2';
import CustomSelectWithSearch from '../../../components/forms/fields/customSelectWithSearch';
import Checkbox from '../../../components/forms/fields/checkbox';
import DatePicker from '../../../components/forms/fields/datePicker';
import TimePickerV2 from '../../../components/forms/fields/timepicker_v2';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { isStringAValidNumber } from '../../../components/TwoFactorAuthModal';
import ErrorModal from '../../../components/errorModal';
import { addMinutesToTime } from '../helper';


function isTimeValidString(timeString) {
    let valid = false;
    if (timeString?.length === 5) {
        const [hours, minutes] = timeString.split(":").map((x) => parseInt(x, 10));
        if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            valid = true;
        }
    }


    return valid;
}


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function truncateString(str) {
    if (str.length > 210) {
        return str.substring(0, 210) + '...';
    }
    return str;
}

class UpdateEventTemplate extends React.Component {

    constructor(props) {
        super(props);

        this.player = React.createRef();
        this.state = {
            ...props.initialData,
            availabilityTemplates: [],
            minTime: '07:00',
            maxTime: '18:00',
        }
        this.state.min = new Date();
        this.state.min.setHours(7, 0, 0)
        this.state.max = new Date();
        this.state.max.setHours(18, 0, 0)
    }
    getWorkingHours = () => {
        const doctorId = this.state.doctorId;
        const clinicId = this.props.selectedClinic;
        const groupId = this.props.selectedGroup;

        if (!doctorId || !clinicId || !groupId) return;

        const obj = {
            clinicianId: doctorId,
            clinicId: clinicId,
            groupId: groupId
        };

        fetch(API_ENDPOINT + `/data/calendar/clinician/working-hours`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {

            let { minTime, maxTime } = result;
            if (!minTime) minTime = '07:00';
            if (!maxTime) maxTime = '18:00';

            let setObj = {};
            if (minTime !== this.state.minTime) {
                setObj.minTime = minTime;
            }
            if (maxTime !== this.state.maxTime) {
                setObj.maxTime = maxTime;
            }
            if (Object.keys(setObj).length > 0) {
                this.setState(setObj)
            }

        })
    }


    stopAnimation = () => {
        this.player.current.play();
    };



    setInitialData = () => {
        this.fetchAvailabilityTemplates();
    }



    fetchAvailabilityTemplates = () => {
        this.setState({ availabilityTemplates: [] }, () => {
            fetch(API_ENDPOINT + '/data/availability-templates/data/fetch', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    userId: this.state.doctorId,
                    groupId: this.props.selectedGroup,
                    clinicId: this.props.selectedClinic
                })
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.items?.length) {
                    this.setState({ availabilityTemplates: result.items })
                }
            })
        })
    }




    componentDidMount() {

        if (this.props.isOpen) {
            let data = this.props.isOpen;
            if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
                let initialTime = this.generateInitialTime();
                data = {
                    ...initialTime,
                    ...data
                }
            }
            this.setState({ data: data, doctorId: data?.doctor }, () => {
                this.getWorkingHours();
                this.setInitialData();
            })
        }

    }
    componentDidUpdate(prevProps, prevState) {
        // if (prevProps.isOpen !== this.props.isOpen) {
        //     let data = this.props.isOpen;
        //     if (!data?.date || !data?.endDate || !data?.startTime || !data?.endTime) {
        //         let initialTime = this.generateInitialTime();
        //         data = {
        //             ...initialTime,
        //             ...data
        //         }
        //     }

        //     this.setState({ data: data })
        // }

    }
    componentWillUnmount() {

    }

    toggle = (notToggle = false, fetchItems = false) => {
        if (this.props.toggle) {
            this.props.toggle(notToggle, fetchItems);
        }
    }
    formatDate = (date, format) => {
        if (!date || !format) return '';
        let dateString = date?.split(' ')?.[0];
        let timeString = date?.split(' ')?.[1];

        let DD = dateString?.split('/')[1];
        let MM = dateString?.split('/')[0];
        let YYYY = dateString?.split('/')[2];
        let HH = timeString?.split(':')[0];
        let mm = timeString?.split(':')[1];

        let formattedDate = format
            .replace('DD', DD)
            .replace('MM', MM)
            .replace('YYYY', YYYY)
            .replace('HH', HH)
            .replace('mm', mm);

        return formattedDate;

    }


    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    generateInitialTime = () => {
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }

        return data;
    }



    deleteEventTemplate = (item, deleteFutureEvents = false, callback) => {

        const eventId = item._id ?? item.id ?? null;
        if (eventId && eventId?.length === 24) {

            this.setState({ loadingDelete: true }, () => {
                fetch(API_ENDPOINT + '/working-hours/event-template/delete', {
                    method: 'POST',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                        eventId: eventId,
                        deleteFutureEvents: deleteFutureEvents
                    })
                }).then(res => res.json()).then((result) => {
                    this.toggle(false, true);
                })
            })

        } else {
            this.setState({ deleteEventTemplateModal: null })
        }
    }
    updateEventTemplate = (item, updateFutureEvents = false) => {
        const eventId = item._id ?? item.id ?? null;

        if (eventId && eventId?.length === 24) {
            let data = {
                title: item.title,
                eventId: eventId,
                date: item.date,
                startTime: item.startTime,
                selectedAvailabilityTemplate: item.selectedAvailabilityTemplate,
                updateFutureEvents: updateFutureEvents,
                startEventReservedDateOriginal: item.date + ' ' + item.startTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(item.date + ' ' + item.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
            }
            let checkDate = new Date(data?.date?.replace(/-/g, "/") + ' ' + data.startTime);
            let today = new Date();

            if (checkDate >= today) {
                this.setState({ loading: true }, () => {
                    fetch(API_ENDPOINT + '/working-hours/event-template/update', {
                        method: 'POST',
                        headers: {
                            'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify(data)
                    }).then(res => res.json()).then((result) => {
                        let setObj = { loading: false, updateEventTemplateModal: null };
                        if (result?.error) {
                            setObj.error = result.error?.translate(this.props.lang);
                        } else {
                            setObj.updateEventTemplateModal = null;
                            setObj.updateEventTemplate = null;

                            if (result?.updatedEvents?.length && this.props.addToUpdatedEvents) {
                                this.props.addToUpdatedEvents(result.updatedEvents);
                            }

                            this.toggle(false, true);
                        }
                        this.setState(setObj)

                    })
                })
            } else {
                this.setState({ wrongDate: true, loading: false })
            }



        } else {
            this.setState({ updateEventTemplateModal: null })
        }
    }
    getDurationOFSelectedTemplate = () => {
        let duration = 5;
        const availabilityTemplates = this.state.availabilityTemplates;
        const selectedTemplateId = this.state.data?.selectedAvailabilityTemplate?.id;

        if (selectedTemplateId) {
            const selectedTemplate = availabilityTemplates.find(item => item._id === this.state.data?.selectedAvailabilityTemplate?.id);
            if (selectedTemplate?.duration) {
                duration = selectedTemplate.duration;
            }
        }

        return duration;
    }

    render() {
        const isOpen = this.props.isOpen ? true : false;
        if (!isOpen || !this.state.data) return null;

        const groupData = this.getGroupData();
        const enterprise = groupData?.enterprise;

        const { minTime, maxTime } = this.state;
        const duration = this.getDurationOFSelectedTemplate();
        console.log("this.state.data", this.state.data)
        return (
            <>
                <Modal isOpen={isOpen} centered>
                    <ModalHeader
                        toggle={() => this.toggle()}
                        close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>}
                    >
                        <div className='modal-header-title-wrap'>
                            {'Edit event'.translate(this.props.lang)}
                            <div className='button-elements-tooltip' style={{ marginLeft: 8 }}>
                                <Isvg src={infoIcon} style={{ width: 25 }} />
                                <div className='tooltip-text' style={{ minWidth: 180, bottom: 29 }}>{'You can only edit...'.translate(this.props.lang)}</div>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label>{'Type'.translate(this.props.lang) + '*'}</Label>
                            <Input
                                type='select'
                                value={this.state.data.type}
                                disabled={true}
                                onChange={(e) => {
                                    return;

                                }}>
                                <option value={-1}>{'Select event type'.translate(this.props.lang)}</option>
                                <option value={'event'}>{'Schedule event'.translate(this.props.lang)}</option>
                                <option value={'free'}>{'Mark as available'.translate(this.props.lang)}</option>
                                <option value={'template'}>{'Add availability template'.translate(this.props.lang)}</option>
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>{'Title'.translate(this.props.lang)}</Label>
                            <Input
                                type='text'
                                value={this.state.data.title}
                                onChange={(e) => {
                                    let data = this.state.data
                                    data.title = e.target.value
                                    this.setState({
                                        data
                                    })
                                }}
                            />
                        </FormGroup>
                        <FormGroup style={{ position: 'relative' }}>
                            <Label>{'Chosen availability template'.translate(this.props.lang)}</Label>
                            <div
                                className={this.state.chooseAvailabilityTemplateOpenMenu ? 'custom-select-with-search-open' : 'custom-select-with-search-closed'}
                                onClick={() => {
                                    this.setState({
                                        chooseAvailabilityTemplateOpenMenu: !this.state.chooseAvailabilityTemplateOpenMenu
                                    })
                                }}
                            >
                                {this.state.availabilityTemplates.map(item => {
                                    let selectedAvailabilityTemplate = this.state.data?.selectedAvailabilityTemplate?.id;
                                    if (selectedAvailabilityTemplate && selectedAvailabilityTemplate === item._id) {
                                        return (
                                            <div className='calendar-select-template-item-wrap'>
                                                <div className='calendar-select-template-item-color' style={{ backgroundColor: item.calendarColor }}></div> {item.name} <span>({item.duration} {"min".translate(this.props.lang)})</span>
                                            </div>
                                        )
                                    }
                                })}

                            </div>

                            {
                                this.state.chooseAvailabilityTemplateOpenMenu ?
                                    <div className='custom-select-with-search-items custom-select-with-search-items-availability-template'>
                                        <CustomSelectWithSearch
                                            lang={this.props.lang}
                                            items={this.state.availabilityTemplates.map((item, idx) => {
                                                return {
                                                    name: item.name,
                                                    nameComponent: <div className='calendar-select-template-item-wrap'>
                                                        <div className='calendar-select-template-item-color' style={{ backgroundColor: item.calendarColor }}></div> {item.name} <span>({item.duration} {"min".translate(this.props.lang)})</span>
                                                    </div>,
                                                    value: item._id
                                                }
                                            })}
                                            value={this.state.data?.selectedAvailabilityTemplate?.id}
                                            maxHeight={'250px'}
                                            onChange={(val) => {
                                                let value = val.value != -1 ? val.value : null;
                                                let data = this.state.data;

                                                let currentTemplate = data?.selectedAvailabilityTemplate?.id ? this.state.availabilityTemplates.find(item => item._id === data.selectedAvailabilityTemplate.id) : null;
                                                let selectedTemplate = this.state.availabilityTemplates.find(item => item._id === value);
                                                data.selectedAvailabilityTemplate = {
                                                    ...data.selectedAvailabilityTemplate,
                                                    id: value
                                                };

                                                if (currentTemplate && selectedTemplate && data.title === currentTemplate?.name) {
                                                    data.title = selectedTemplate?.name;
                                                }

                                                this.setState({ data }, () => {
                                                    this.setState({
                                                        chooseAvailabilityTemplateOpenMenu: false
                                                    })
                                                })
                                            }
                                            }
                                        />
                                    </div>
                                    :
                                    null
                            }

                        </FormGroup>




                        <div className='time-wrap' style={{ alignItems: this.state.data.type === 'template' && this.state.data.selectedAvailabilityTemplate?.id ? 'center' : 'flex-start' }}>
                            <div className='update-event-template-time-component-wrap'>
                                <DatePicker
                                    label={'Date'.translate(this.props.lang)}
                                    value={this.state.data.date}
                                    holidayEvents={this.state.holidayEvents}
                                    onChange={(e) => {
                                        let data = this.state.data;
                                        data.date = e;
                                        this.setState({
                                            data
                                        })
                                        if (Math.floor(new Date(this.state.data.date + ' ' + this.state.data.startTime) / 1000) > Math.floor(new Date(this.state.data.endDate + ' ' + this.state.data.endTime) / 1000)) {
                                            data.endDate = this.state.data.date
                                            this.setState({
                                                data
                                            })
                                        }
                                    }}
                                />
                                <FormGroup className="timepicker-container timepicker-wide">
                                    <Label>{'Start time'.translate(this.props.lang)}</Label>
                                    &nbsp;
                                    <TimePickerV2
                                        getStringDateTs={this.props.getStringDateTs}
                                        format={'HH:mm'}
                                        value={this.state.data.startTime}
                                        // minValue={this.props.getStringDateTs(Math.floor(this.state.min.getTime() / 1000), 'HH:mm')}
                                        // maxValue={this.props.getStringDateTs(Math.floor(this.state.max.getTime() / 1000 - 300), 'HH:mm')}
                                        minValue={minTime}
                                        maxValue={addMinutesToTime(maxTime, duration > 0 ? -duration : -5)}
                                        flag={0}
                                        onChange={(time1, timeString) => {

                                            let data = this.state.data;
                                            data.startTime = timeString

                                            let startTimeSplit = data.startTime.split(":");
                                            let endTimeSplit = data.endTime.split(":");


                                            let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                            let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                            if (startTimeHourMinute < endTimeHourMinute) {
                                                this.setState({ data })
                                            } else {
                                                data.endTime = Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60
                                                const padded = data?.endTime?.split?.(':');
                                                if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                    const h = padded[0]?.padStart?.(2, '0');
                                                    const m = padded[1]?.padStart?.(2, '0');
                                                    if (h && m) data.endTime = `${h}:${m}`;
                                                }
                                                this.setState({
                                                    data
                                                })
                                            }


                                        }}
                                    />

                                </FormGroup>
                            </div>


                        </div>


                        {this.state.errorEvent ? <FormFeedback >{this.state.errorEvent}</FormFeedback> : null}




                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>

                        <Button
                            className="apply-button"
                            color='primary'
                            onClick={() => {
                                let date = moment.unix(Math.floor(new Date(this.state.data.date).getTime() / 1000)).format('MM/DD/YYYY');
                                let startTime = this.state.data.startTime;
                                let _date = moment.unix(Math.floor(new Date(this.state.data._date).getTime() / 1000)).format('MM/DD/YYYY');
                                let _startTime = this.state.data._startTime;
                                let disabledFutureUpdate = false;
                                if (_startTime !== startTime || _date !== date) {
                                    disabledFutureUpdate = true;
                                }
                                if (this.state.data)
                                    this.setState({ updateEventTemplateModal: { ...this.state.data, disabledFutureUpdate } })
                            }}>
                            {this.state.loading ?

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Player
                                        onEvent={() => {
                                            if (!this.state.loading) this.stopAnimation();
                                        }}
                                        onStateChange={this.toggleVisibility}
                                        ref={this.player} // set the ref to your class instance
                                        autoplay={true}
                                        loop={true}
                                        controls={true}
                                        src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                        style={{ height: "20px", width: "30px" }}
                                    ></Player>
                                    {'Processing...'.translate(this.props.lang)}
                                </div>

                                : 'Set'.translate(this.props.lang)}
                        </Button>
                        <Button
                            className="cancel-template-button"
                            color='primary'
                            onClick={() => {
                                this.setState({ deleteEventTemplateModal: { ...this.state.data } })
                            }}>
                            {this.state.loadingDelete ?

                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Player
                                        onEvent={() => {
                                            if (!this.state.loadingDelete) this.stopAnimation();
                                        }}
                                        onStateChange={this.toggleVisibility}
                                        ref={this.player}
                                        autoplay={true}
                                        loop={true}
                                        controls={true}
                                        src="https://assets8.lottiefiles.com/packages/lf20_ZSRKCF.json"
                                        style={{ height: "20px", width: "30px" }}
                                    ></Player>
                                    {'Processing...'.translate(this.props.lang)}
                                </div>

                                : 'Cancel time'.translate(this.props.lang)}
                        </Button>

                        <Button
                            className="book-vitit-from-template-button"
                            color='primary'
                            onClick={() => {
                                if (this.props.bookVisitFromTemplate) {
                                    this.props.bookVisitFromTemplate();
                                }
                            }}
                        >{'Book visit from template'.translate(this.props.lang)}</Button>
                        <Button
                            className="cancel-modal-button"
                            color='primary'
                            onClick={() => {
                                this.toggle();
                            }}
                        >{'Cancel'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                    <div style={{ margin: '5px 15px' }}>
                        {
                            this.state.data?.tsCreated && this.state.data?.tsModified && this.state.data?.tsCreated !== this.state.data?.tsModified ?
                                <div className='info-message-update-wrap'>
                                    {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.data?.tsCreated, `${this.props.dateFormat} HH:mm`)}. ${'Last update:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.data?.tsModified, `${this.props.dateFormat} HH:mm`)}`}
                                </div>
                                :
                                this.state.data?.tsCreated ?
                                    <div className='info-message-update-wrap'>
                                        {`${'Created on:'.translate(this.props.lang)} ${this.props.getStringDateTs(this.state.data?.tsCreated, `${this.props.dateFormat} HH:mm`)}`}
                                    </div>
                                    :
                                    null

                        }
                    </div>

                </Modal >

                {
                    this.state.deleteEventTemplateModal ?
                        <Modal isOpen={this.state.deleteEventTemplateModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to cancel this event only, or this and all future events?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete}
                                    color='primary'
                                    onClick={() => {
                                        this.deleteEventTemplate(this.state.deleteEventTemplateModal, false)
                                    }}
                                >
                                    {'This event only'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    disabled={this.state.loadingDelete}
                                    color='primary'
                                    onClick={() => {
                                        this.deleteEventTemplate(this.state.deleteEventTemplateModal, true)
                                    }}
                                >
                                    {'This event and future events'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ deleteEventTemplateModal: !this.state.deleteEventTemplateModal })}>
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.updateEventTemplateModal ?
                        <Modal isOpen={this.state.updateEventTemplateModal} centered >
                            <ModalBody className="delete-modal">
                                <div className='message' style={{ padding: 20 }}>
                                    {'Do you want to apply this changes to this event only, or this and all future events?'.translate(this.props.lang)}
                                </div>
                            </ModalBody>
                            <ModalFooter
                                className='modal-footer-buttons-wrap'
                                style={{ justifyContent: 'center' }}
                            >
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loading}
                                    color='primary'
                                    onClick={() => {
                                        this.updateEventTemplate(this.state.updateEventTemplateModal, false)
                                    }}
                                >
                                    {'This event only'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    disabled={this.state.loadingDelete || this.state.loading || this.state.updateEventTemplateModal?.disabledFutureUpdate}
                                    color='primary'
                                    onClick={() => {
                                        this.updateEventTemplate(this.state.updateEventTemplateModal, true)

                                    }}
                                >
                                    {'This event and future events'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color='primary'
                                    onClick={() => this.setState({ updateEventTemplateModal: !this.state.updateEventTemplateModal })}>
                                    {'Cancel'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error}
                        </ErrorModal>

                        :
                        null
                }
                {
                    this.state.wrongDate ?
                        <Modal isOpen={this.state.wrongDate} centered>
                            <ModalBody className="delete-modal">
                                <p className='message'>{'You can not pick date form the past'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className="buttons-right-blue">
                                <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ wrongDate: !this.state.wrongDate })}>{'Pick again'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }
            </>


        )
    }
}

export default UpdateEventTemplate;